<template lang="pug">
  v-col(
    xl="3" lg="4" md="6" cols="12"
  )
    v-card(
      @click="path"
      flat
      :outlined="outlined"
    ).course-card.course-card--hover
      v-img(
        :lazy-src="require('@/assets/course-sample.png')"
        :src="course.image ? course.image.url : require('@/assets/course-sample.png')"
        height="230"
        alt="Изображение курса"
      ).course-card__image.text-right
        span(v-if="course.type_activity_name" class="course-card__activity px-3 py-1 ma-4")
          | {{ course.type_activity_name }}
        tooltip-wrap(
          text="Страница курса"
        )
          v-btn.mr-6.mt-4(
            v-if="editable"
            fab depressed small
            color="secondary"
            @click.stop.prevent="to"
          )
            v-icon(small) mdi-page-layout-body

      .fill-height.pa-5(
        :class="{ 'sdo-shadow': !outlined }"
      )
        .caption.mx-3.d-flex.align-center.grey--text.text--darken-2
          div
            v-icon.mr-2 mdi-image-filter-none
            span {{ $tc('units', course.course_units_count) }}
          v-spacer
          tooltip-wrap(
            text="Продолжительность курса"
          )
            v-icon.mr-2 mdi-clock-outline
            span {{ $tc('hours', course.duration) }}
        slot(name="main-info" :course="course")
          v-card-subtitle.pb-2: strong {{ course.title }}
          v-card-text(
            v-if="!study"
            class="course-description"
          ).pb-0 {{ course.description }}

          v-card-text(v-if="isExchange")
            v-row(v-if="course.price")
              v-col.text-center
                v-tooltip(top)
                  template(v-slot:activator="{ on }")
                    span(v-on="on")
                      | Стоимость: {{ course.price || 0 }}
                      v-icon(left) mdi-currency-rub
                  span Стоимость курса
          v-card-text(v-if="study").pb-0
            template(v-if="course.priority_user_prior_record")
              record-status-wrap(
                :user-record="course.priority_user_prior_record.user_record"
                v-slot:default="{ color, label }"
              ).pt-3
                v-alert(
                  :color="color"
                  text
                  icon="mdi-account-school"
                  prominent
                )
                  .ml-2
                    strong(
                      v-if="course.priority_user_prior_record.user_record.group"
                    ).mb-1 {{ course.priority_user_prior_record.user_record.group.short_name }}
                    div {{ label }}
      .pb-4.px-4
        slot(name="actions" :course="course")
          v-card-actions.pa-0.mx-2(v-if="$user.isAuthenticated")
            v-btn(
              v-if="$user.data.role === $conf.ROLES.organization.value && isExchange"
              :to="{ name: 'NewCourseRequest', params: { id: course.id }}"
              color="primary"
              depressed
              rounded
              large
            ) Купить
            .d-flex.align-center.fill-width(v-if="canEnroll")
              template(v-if="course.is_related_pfdo")
                v-spacer
                .flex-grow.text-right.d-flex
                  .caption Запись доступна только в ПФДО
                  v-icon.ml-2 mdi-information
            template(
              v-if="editable"
            )
              v-btn.px-3(
                outlined
                rounded
                color="secondary"
                @click.stop="$router.push({ name: 'CourseEnrollment', params: { id: course.id }})"
              ) К наборам
              v-spacer

              tooltip-wrap(
                text="Настройки курса"
              )
                v-btn(
                  fab small
                  depressed
                  color="secondary"
                  @click.stop="$router.push({ name: 'CourseSettings', params: { id: course.id }})"
                )
                  v-icon(small) mdi-cog
            //- v-menu(
            //-   v-if="editable"
            //-   bottom
            //-   center
            //-   offset-y
            //-   transition="slide-y-transition"
            //- )
              template(v-slot:activator="{ on }")
                v-btn(
                  v-on="on"
                  color="primary"
                  text
                  rounded
                  small
                  @click.stop.prevent
                ).mt-2
                  span Действия
                  v-icon(right) mdi-chevron-down
              v-list(nav)
                v-list-item(:to="{ name: 'CourseUnits', params: { id: course.id }}")
                  v-list-item-title
                    v-icon(class="mr-4") mdi-list-box-outline
                    | Структура
                v-list-item(:to="{ name: 'CourseEnrollment', params: { id: course.id }}")
                  v-list-item-title
                    v-icon(class="mr-4") mdi-account-multiple
                    | Наборы
                v-list-item(
                  :to="{ name: 'CourseManagementConstructor', params: { id: course.id } }")
                  v-list-item-title
                    v-icon(class="mr-4") mdi-page-layout-body
                    | Страница курса
                //- v-list-item(:to="{ name: 'CourseSettings', params: { id: course.id }}")
                //-   v-list-item-title
                //-     v-icon(class="mr-4") mdi-cog
                //-     | Настройки
</template>

<script>
import anime from 'animejs';

import { COURSE_STATUSES } from '@/utils/constants';

import RecordStatusWrap from '@/components/Enrollment/RecordStatusWrap.vue';

export default {
  name: 'CourseCard',
  components: {
    RecordStatusWrap,
  },
  props: {
    course: {
      type: Object,
      default: () => ({}),
    },
    isExchange: {
      type: Boolean,
      default: false,
    },
    editable: { type: Boolean, default: false },
    study: { type: Boolean, default: false },
    // curator: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
  },
  data: () => ({
    COURSE_STATUSES,
    loading: false,
  }),
  computed: {

    organizationShortName() {
      if (!this.course.organizations) return null;
      const [mainOrganization] = this.course.organizations;
      return mainOrganization && mainOrganization.short_name;
    },
    courseCountLessons() {
      return this.course.lessons.length;
    },
    canEnroll() {
      return [
        this.$conf.ROLES.student.value,
        this.$conf.ROLES.listener.value,
      ] === this.$user.data.role && !this.isExchange;
    },
  },
  mounted() {
    this.animateCoursesDisplay();
  },
  methods: {
    to() {
      this.$router.push({ name: 'CourseManagementConstructor', params: { id: this.course.id } });
    },
    path() {
      let path;
      if (this.study) {
        path = {
          name: 'EducationCourseUnitList',
          params: { courseId: this.course.id, groupId: this.course.user_group_id },
        };
      } else if (this.editable) {
        path = { name: 'CourseUnits', params: { id: this.course.id } };
      } else {
        path = { name: 'CourseView', params: { id: this.course.id } };
      }
      this.$router.push(path);
    },
    animateCoursesDisplay() {
      anime({
        targets: '.course-card',
        translateY: [300, 0],
        opacity: [0, 1],
        duration: 600,
        autoplay: true,
        easing: 'easeOutExpo',
        delay: anime.stagger(100),
      });
    },
  },
};
</script>

<style lang="scss" scoped>

  .course-card {
    opacity: 0;
    height: 100%;
    border-radius: 30px !important;
    display: flex;
    flex-direction: column;

    &__activity {
      background-color: var(--v-primary-base);
      border-color: var(--v-primary-base);
      color: #fff;
      caret-color: #fff;
      display: inline-block;
      border-radius: 4px;
    }
  }

  .sdo-card__image:hover {
    cursor: pointer;
  }

  .sdo-card .v-card__title {
    line-height: 1.3;

    &:hover {
      cursor: pointer;
    }
  }
</style>

<style lang="scss">

  // .course-card__image .v-image__image {
  //   transition: all .2s;
  //   // background-size: 100%;
  //   object-fit: cover;
  // }

  // .course-card__image:hover .v-image__image {
  //   background-size: 110%;
  // }
</style>
